import { render, staticRenderFns } from "./RegistersIndex.vue?vue&type=template&id=0069c158"
import script from "./RegistersIndex.vue?vue&type=script&lang=js"
export * from "./RegistersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports